import {
  faCheckCircle,
  faTimesCircle,
  IconDefinition,
} from '@fortawesome/pro-solid-svg-icons';
import { capitalize } from 'lodash';
import { FC, useCallback } from 'react';
import { OperatorRequest } from 'src/apis/contract-management/use-operator-by-tso';
import { Card } from 'src/components/data-display/card';
import { Stack } from 'src/components/layout/stack';
import { Heading } from 'src/components/text/heading';
import { useBreakpoints } from 'src/hooks/use-breakpoints';
import { MarketAreaCoordinatorMailedStatus } from 'src/pages/operators/assignments/details/components/market-area-coordinator-mailed-status';
import { PaymentEscalation } from 'src/pages/operators/assignments/details/components/payment-escalation';
import { LabelWithIcon } from 'src/pages/operators/assignments/overview/components/label-with-icon';
import { AssignmentsOrganisationItem } from 'src/pages/operators/assignments/overview/types';
import { AssignmentBadge } from 'src/pages/shipper-admin/details/assignment-badge';
import { Colors } from 'src/styles';

type Props = {
  orgAssignment: AssignmentsOrganisationItem & { transferCompanyData: boolean };
  caMaOperator?: OperatorRequest;
  title: string;
};

export const AssignmentDetailsOrganisationStatus: FC<Props> = ({
  orgAssignment,
  caMaOperator,
  title,
}) => {
  const { minDesktop } = useBreakpoints();

  const setMarketIndicator = useCallback(
    (market: 'PRIMARY' | 'SECONDARY') => {
      let icon: IconDefinition = faTimesCircle;
      let iconColor = Colors.error;
      if ((orgAssignment.marketAccess as string[]).includes(market)) {
        icon = faCheckCircle;
        iconColor = Colors.success;
      }
      return (
        <LabelWithIcon
          icon={icon}
          label={`${capitalize(market)} Market`}
          color={iconColor}
        />
      );
    },
    [orgAssignment.marketAccess]
  );

  return (
    <Card data-testid="organisation-assignment-status">
      <Stack gap={1} alignItems="center">
        <Stack flow="column" justifyContent="space-between" gap={2}>
          <Heading mode="card">{title}</Heading>
        </Stack>
        <Stack flow="column" gap={1} justifyContent="space-between">
          <AssignmentBadge value={orgAssignment.status} />
          <Stack
            flow="column"
            justifyContent={minDesktop ? 'end' : 'start'}
            gap={2}
          >
            {orgAssignment.status === 'APPROVED' &&
              orgAssignment.marketAccess &&
              setMarketIndicator('PRIMARY')}
            {orgAssignment.status === 'APPROVED' &&
              orgAssignment.marketAccess &&
              setMarketIndicator('SECONDARY')}

            {orgAssignment.status ===
              'NOT_APPROVED' /* Waiting for Approval */ && (
              <MarketAreaCoordinatorMailedStatus
                isMailed={orgAssignment.transferCompanyData}
              />
            )}
          </Stack>
        </Stack>

        {caMaOperator?.response ? (
          <PaymentEscalation operator={caMaOperator.response.data} />
        ) : null}
      </Stack>
    </Card>
  );
};
